import {
    BLOCK_USERDETAILS_SUCCESS,
    BLOCK_USERDETAILS_FAILED,
    RESET_BLOCK_USERDETAILS,
    LOADING_BLOCK_USERDETAILS,
    BLOCK_USERDETAILS_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BLOCK_USERDETAILS:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BLOCK_USERDETAILS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BLOCK_USERDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case BLOCK_USERDETAILS_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BLOCK_USERDETAILS:
            return (state = initialState);
        default:
            return state;
    }
};
